{
    "NAME": "AbandonedTimeStatisticLanguage",
    "sectionHeader": "Abandoned Time Statistic",
    "sectionPara": "You can also specifically adjust the abandoned duration threshold(s), which are used by the seven \"Abandoned <= Xs\" style inbound abandoned statistic variants.",
    "target1Label": "Target 1:",
    "target1Placeholder": "60",
    "target2Label": "Target 2:",
    "target2Placeholder": "90",
    "target3Label": "Target 3:",
    "target3Placeholder": "120",
    "target4Label": "Target 4:",
    "target4Placeholder": "150",
    "target5Label": "Target 5:",
    "target5Placeholder": "180",
    "target6Label": "Target 6:",
    "target6Placeholder": "300",
    "targetUnits": "s",
    "resetAnswerTargetsButtonLabel": "Reset Abandoned Intervals",
    "resetAnswerTargetsPrompt": "Are you sure you wish to reset all 6 inbound abandoned threshold settings back to their default values?",
    "resetAnswerTargetsConfirm": "Confirm",
    "resetAnswerTargetsCancel": "Cancel"
}